import Vue from 'vue';
import { keys } from 'lodash';
import * as C from './list';

keys(C).map(name => Vue.component(`app-${name.toLowerCase()}`, C[name]));
